'use client';

import { twMerge } from 'tailwind-merge';
import { IBoundingBox } from '../../../../interfaces/geo';
import { GetRegionTopSpecies_topSpeciesNearLocation_edges_node } from '../../../../interfaces/graphql';
import { useFeatureFlags } from '../../../../helpers/hooks/useFeatureFlags';
import { SpeciesGroupSection } from '../../../../components/SpeciesGroupSection/SpeciesGroupSection';
import { TopSpeciesSection } from '../../../../components/TopSpeciesSection/TopSpeciesSection';
import { ISpeciesGrouping } from '../../../../constants/species/types';

const DEFAULT_MAX_VISIBLE_ITEMS = 3;

interface IProps {
  appDownloadModalHeader?: string;
  boundingBox?: IBoundingBox;
  className?: string;
  countryCode?: string;
  regionCode?: string;
  id?: string;
  clickEventSourceId?: string;
  headingText?: string;
  topSpecies: GetRegionTopSpecies_topSpeciesNearLocation_edges_node[];
  speciesGroups?: ISpeciesGrouping[];
  nrOfVisibleItems?: number;
}

export const SpeciesSection = ({
  appDownloadModalHeader = `Download the Fishbrain app to see all species from this area`,
  boundingBox,
  clickEventSourceId,
  countryCode,
  regionCode,
  headingText = `Top fish species in this area`,
  id = 'top-species-section',
  topSpecies,
  speciesGroups,
  className,
  nrOfVisibleItems = DEFAULT_MAX_VISIBLE_ITEMS,
}: IProps) => {
  const featureflags = useFeatureFlags(['groupRegionPages']);

  // Todo remove feature flag when ready to launch FIB-48150
  if (featureflags.groupRegionPages && countryCode && regionCode && speciesGroups) {
    return (
      <SpeciesGroupSection
        headingText={headingText}
        className="h-full sm:px-8 sm:pt-6 sm:pb-2"
        speciesGroups={speciesGroups}
        countryCode={countryCode}
        regionCode={regionCode}
        nrOfVisibleItems={speciesGroups.length}
        hasDownloadCTA={false}
      />
    );
  }

  return (
    <TopSpeciesSection
      id={id}
      className={twMerge('bg-white px-6 py-8 sm:px-11 sm:py-10', className)}
      headingText={headingText}
      topSpecies={topSpecies}
      boundingBox={boundingBox}
      clickEventSourceId={clickEventSourceId}
      appDownloadModalHeader={appDownloadModalHeader}
      nrOfVisibleItems={nrOfVisibleItems}
    />
  );
};
